// Bands Trainers Data - Using the bands coding system (lcbors)
// COMPLETE VERSION - 6 programs per trainer

// Oliver Bennett's workout programs (extracted from Android data)
const oliverBennettPrograms = [
    {
        id: 'flexibility-focus',
        name: 'Flexibility Focus',
        description: 'This specialized program focuses on developing tissue extensibility, joint mobility, and fascial release through progressive stretching protocols with resistance bands.',
        pattern: 'lccrc', // leg, chest, chest, arm, chest (based on pattern analysis)
        reps: 8,
        sets: 3,
        focus: 'Flexibility & Mobility'
    },
    {
        id: 'mobility-enhancement',
        name: 'Mobility Enhancement',
        description: 'True mobility requires both flexibility and strength through a complete range of motion, developed through strategic band resistance.',
        pattern: 'lsscr', // leg, shoulder, shoulder, chest, arm
        reps: 8,
        sets: 3,
        focus: 'Mobility Development'
    },
    {
        id: 'dynamic-stretching',
        name: 'Dynamic Stretching',
        description: 'Dynamic stretching combines movement with progressive range expansion through controlled band resistance.',
        pattern: 'cbbor', // chest, back, back, core, arm
        reps: 8,
        sets: 3,
        focus: 'Dynamic Movement'
    },
    {
        id: 'band-flow',
        name: 'Band Flow',
        description: 'Resistance band training provides variable resistance through full ranges of motion for fluid movement development.',
        pattern: 'bcslo', // back, chest, shoulder, leg, core
        reps: 8,
        sets: 3,
        focus: 'Flow Training'
    },
    {
        id: 'range-of-motion',
        name: 'Range of Motion',
        description: 'Optimal range of motion requires methodical development of end-range strength through controlled band resistance.',
        pattern: 'bosc', // back, core, shoulder, chest
        reps: 8,
        sets: 4,
        focus: 'ROM Development'
    },
    {
        id: 'posture-correction',
        name: 'Posture Correction',
        description: 'Optimal posture requires both mobility and targeted strengthening through strategic band exercises.',
        pattern: 'sbolr', // shoulder, back, core, leg, arm
        reps: 8,
        sets: 3,
        focus: 'Postural Health'
    }
];

// Max Rodriguez's workout programs (extracted from Android data)
const maxRodriguezPrograms = [
    {
        id: 'strength-builder',
        name: 'Strength Builder',
        description: 'This specialized program focuses on developing foundational strength through compound movements and progressive band loading.',
        pattern: 'sclbr', // shoulder, chest, leg, back, arm
        reps: 8,
        sets: 3,
        focus: 'Strength Foundation'
    },
    {
        id: 'muscle-mass',
        name: 'Muscle Mass',
        description: 'Optimal hypertrophy requires the right combination of volume, intensity, and recovery through strategic band resistance.',
        pattern: 'clsbr', // chest, leg, shoulder, back, arm
        reps: 8,
        sets: 3,
        focus: 'Mass Building'
    },
    {
        id: 'progressive-resistance',
        name: 'Progressive Resistance',
        description: 'Continuous adaptation requires strategic progression of resistance patterns through varied band loading.',
        pattern: 'bbrcs', // back, back, arm, chest, shoulder
        reps: 8,
        sets: 3,
        focus: 'Progressive Training'
    },
    {
        id: 'power-development',
        name: 'Power Development',
        description: 'Power development bridges the gap between strength and speed through explosive band training.',
        pattern: 'cslro', // chest, shoulder, leg, arm, core
        reps: 8,
        sets: 3,
        focus: 'Power Training'
    },
    {
        id: 'compound-movements',
        name: 'Compound Movements',
        description: 'Multi-joint exercises deliver the greatest growth stimulus through integrated band resistance.',
        pattern: 'boclr', // back, core, chest, leg, arm
        reps: 8,
        sets: 4,
        focus: 'Compound Training'
    },
    {
        id: 'hypertrophy-focus',
        name: 'Hypertrophy Focus',
        description: 'Maximum muscle growth requires strategic targeting of all growth mechanisms through varied band resistance.',
        pattern: 'sborc', // shoulder, back, core, arm, chest
        reps: 8,
        sets: 3,
        focus: 'Hypertrophy Training'
    }
];

// Zoe Harper's workout programs (extracted from Android data)
const zoeHarperPrograms = [
    {
        id: 'functional-movement',
        name: 'Functional Movement',
        description: 'This specialized program focuses on developing movement efficiency and motor control through integrated band patterns.',
        pattern: 'soclr', // shoulder, core, chest, leg, arm
        reps: 8,
        sets: 3,
        focus: 'Functional Training'
    },
    {
        id: 'movement-patterns',
        name: 'Movement Patterns',
        description: 'Optimal movement requires mastery of fundamental human movement patterns through strategic band resistance.',
        pattern: 'slcor', // shoulder, leg, chest, core, arm
        reps: 8,
        sets: 3,
        focus: 'Pattern Development'
    },
    {
        id: 'athletic-performance',
        name: 'Athletic Performance',
        description: 'True athletic movement requires integration of strength, coordination and mobility through dynamic band training.',
        pattern: 'cbors', // chest, back, core, arm, shoulder
        reps: 8,
        sets: 3,
        focus: 'Athletic Development'
    },
    {
        id: 'core-integration',
        name: 'Core Integration',
        description: 'The core functions as the central link in all movement chains, developed through integrated band resistance.',
        pattern: 'oclsl', // core, chest, leg, shoulder, leg
        reps: 8,
        sets: 3,
        focus: 'Core Training'
    },
    {
        id: 'full-body-coordination',
        name: 'Full-Body Coordination',
        description: 'Whole-body coordination is the highest expression of movement intelligence through complex band sequences.',
        pattern: 'sllbo', // shoulder, leg, leg, back, core
        reps: 8,
        sets: 4,
        focus: 'Coordination Training'
    },
    {
        id: 'balance-stability',
        name: 'Balance & Stability',
        description: 'Optimal movement requires both dynamic stability and precise control through challenging band exercises.',
        pattern: 'soblr', // shoulder, core, back, leg, arm
        reps: 8,
        sets: 3,
        focus: 'Balance Training'
    }
];

// Nathan Brooks's workout programs (extracted from Android data)
const nathanBrooksPrograms = [
    {
        id: 'injury-recovery',
        name: 'Injury Recovery',
        description: 'This specialized program focuses on rebuilding tissue integrity and movement confidence through progressive band rehabilitation.',
        pattern: 'srcbo', // shoulder, arm, chest, back, core
        reps: 8,
        sets: 3,
        focus: 'Recovery Training'
    },
    {
        id: 'joint-mobility',
        name: 'Joint Mobility',
        description: 'Optimal joint function requires both mobility and stability through complete range of motion band training.',
        pattern: 'scrlo', // shoulder, chest, arm, leg, core
        reps: 8,
        sets: 3,
        focus: 'Joint Health'
    },
    {
        id: 'rehab-progression',
        name: 'Rehab Progression',
        description: 'Rehabilitation success requires strategic progression from isolation to integration through systematic band training.',
        pattern: 'bosrc', // back, core, shoulder, arm, chest
        reps: 8,
        sets: 3,
        focus: 'Progressive Rehab'
    },
    {
        id: 'pain-relief',
        name: 'Pain Relief',
        description: 'Addressing pain requires both symptom management and underlying cause correction through therapeutic band exercises.',
        pattern: 'cslor', // chest, shoulder, leg, core, arm
        reps: 8,
        sets: 3,
        focus: 'Pain Management'
    },
    {
        id: 'movement-therapy',
        name: 'Movement Therapy',
        description: 'Movement is medicine when applied with precision and purpose through targeted therapeutic band exercises.',
        pattern: 'cblso', // chest, back, leg, shoulder, core
        reps: 8,
        sets: 4,
        focus: 'Movement Therapy'
    },
    {
        id: 'corrective-exercise',
        name: 'Corrective Exercise',
        description: 'Optimal function requires identifying and correcting movement dysfunctions through strategic band exercises.',
        pattern: 'sbcor', // shoulder, back, chest, core, arm
        reps: 8,
        sets: 3,
        focus: 'Corrective Training'
    }
];

// Jasmine Carter's workout programs (extracted from Android data)
const jasmineCarterPrograms = [
    {
        id: 'athletic-conditioning',
        name: 'Athletic Conditioning',
        description: 'This specialized program focuses on developing athletic capacity and recovery efficiency through progressive band conditioning.',
        pattern: 'sclobr', // shoulder, chest, leg, core, back, arm
        reps: 8,
        sets: 3,
        focus: 'Athletic Conditioning'
    },
    {
        id: 'sports-performance',
        name: 'Sports Performance',
        description: 'Elite sports performance requires a blend of strength, power, and skill development through sport-specific band training.',
        pattern: 'slorc', // shoulder, leg, core, arm, chest
        reps: 8,
        sets: 3,
        focus: 'Sports Training'
    },
    {
        id: 'speed-agility',
        name: 'Speed & Agility',
        description: 'True speed development requires both linear acceleration and multidirectional agility through dynamic band training.',
        pattern: 'clrbs', // chest, leg, arm, back, shoulder
        reps: 8,
        sets: 3,
        focus: 'Speed Development'
    },
    {
        id: 'explosive-power',
        name: 'Explosive Power',
        description: 'Explosive power is generated through the perfect balance of strength and speed using progressive band techniques.',
        pattern: 'cslbr', // chest, shoulder, leg, back, arm
        reps: 8,
        sets: 3,
        focus: 'Explosive Training'
    },
    {
        id: 'high-intensity-circuit',
        name: 'High-Intensity Circuit',
        description: 'Circuit training creates the perfect storm of metabolic stress and neuromuscular challenge through band complexes.',
        pattern: 'orlbc', // core, arm, leg, back, chest
        reps: 8,
        sets: 4,
        focus: 'HIIT Training'
    },
    {
        id: 'endurance-builder',
        name: 'Endurance Builder',
        description: 'Athletic endurance requires both cardiovascular efficiency and muscular stamina through sustained band resistance.',
        pattern: 'lcsbr', // leg, chest, shoulder, back, arm
        reps: 8,
        sets: 3,
        focus: 'Endurance Training'
    }
];

// Caleb Mitchell's workout programs (extracted from Android data)
const calebMitchellPrograms = [
    {
        id: 'dynamic-resistance',
        name: 'Dynamic Resistance',
        description: 'This specialized program focuses on developing strength through active resistance with changing force vectors.',
        pattern: 'csolr', // chest, shoulder, core, leg, arm
        reps: 8,
        sets: 3,
        focus: 'Dynamic Training'
    },
    {
        id: 'variable-tension',
        name: 'Variable Tension',
        description: 'Muscles respond optimally to resistance that changes throughout the movement arc through variable band tension.',
        pattern: 'sclbr', // shoulder, chest, leg, back, arm
        reps: 8,
        sets: 3,
        focus: 'Variable Resistance'
    },
    {
        id: 'progressive-overload',
        name: 'Progressive Overload',
        description: 'Strategic progression of resistance is the fundamental principle of strength development through systematic band loading.',
        pattern: 'sborc', // shoulder, back, core, arm, chest
        reps: 8,
        sets: 3,
        focus: 'Progressive Training'
    },
    {
        id: 'tempo-training',
        name: 'Tempo Training',
        description: 'Controlling movement speed is one of the most underutilized forms of resistance through strategic tempo manipulation.',
        pattern: 'clsor', // chest, leg, shoulder, core, arm
        reps: 8,
        sets: 3,
        focus: 'Tempo Control'
    },
    {
        id: 'multi-angle-resistance',
        name: 'Multi-Angle Resistance',
        description: 'Complete muscle development requires force application from multiple angles through three-dimensional band training.',
        pattern: 'cslobr', // chest, shoulder, leg, core, back, arm
        reps: 8,
        sets: 4,
        focus: 'Multi-Angle Training'
    },
    {
        id: 'band-complexes',
        name: 'Band Complexes',
        description: 'Resistance band complexes create unique challenge patterns impossible with conventional weights through integrated sequences.',
        pattern: 'soclbr', // shoulder, core, chest, leg, back, arm
        reps: 8,
        sets: 3,
        focus: 'Complex Training'
    }
];

// Bands trainers data structure
const bandsTrainersData = {
    'oliver-bennett': {
        id: 'oliver-bennett',
        name: 'Oliver Bennett',
        specialization: 'Functional Movement Specialist',
        image: '/assets/images/v25.jpg',
        experience: '10+ Years',
        category: 'bands',
        intro: `Oliver Bennett transformed his approach to fitness after overcoming a debilitating injury through resistance band training and mobility work. With his lean, functional physique, thoughtful demeanor, and methodical approach, Oliver specializes in flexibility-focused training that enhances range of motion while building functional strength. After years of developing rehabilitation programs for professional athletes, he refined his methodology to make advanced mobility accessible through progressive resistance band work. "Movement quality precedes movement quantity," is his guiding principle when coaching. Oliver's unique background combining physical therapy, flexibility training, and resistance work creates programs that develop not just impressive mobility but extraordinary functional capabilities rarely seen in conventional fitness.`,
        programs: oliverBennettPrograms
    },
    'max-rodriguez': {
        id: 'max-rodriguez',
        name: 'Max Rodriguez',
        specialization: 'Athletic Performance Specialist',
        image: '/assets/images/v39.jpg',
        experience: '12+ Years',
        category: 'bands',
        intro: `Max Rodriguez built his reputation through competitive bodybuilding and later as an elite strength coach. With his massive muscular build, commanding presence, and methodical approach, Max specializes in resistance training that combines old-school intensity with scientific programming. After winning several professional competitions, he developed his systematic approach to help athletes maximize their strength and muscle development potential. "Progressive overload is the foundation of all physical development," is his core training philosophy. Max's background blending traditional bodybuilding, strength athletics, and sports science creates uniquely effective programs that develop exceptional muscular development alongside impressive functional strength.`,
        programs: maxRodriguezPrograms
    },
    'zoe-harper': {
        id: 'zoe-harper',
        name: 'Zoe Harper',
        specialization: 'Total Body Conditioning Specialist',
        image: '/assets/images/v61.jpg',
        experience: '9+ Years',
        category: 'bands',
        intro: `Zoe Harper discovered his passion for functional fitness through his background in dance, gymnastics, and physical therapy. With his lean, athletic physique, energetic presence, and detailed approach, Zoe specializes in movement-based training that emphasizes functional patterns and integrated mobility. After overcoming a career-threatening injury using resistance bands and functional movement, he developed comprehensive training systems accessible to all fitness levels. "Movement quality determines your potential for growth and longevity," is his core training philosophy. Zoe's diverse background blending dance, rehabilitation, and strength training creates distinctively effective programs that develop exceptional movement quality alongside impressive physical capabilities.`,
        programs: zoeHarperPrograms
    },
    'nathan-brooks': {
        id: 'nathan-brooks',
        name: 'Nathan Brooks',
        specialization: 'Strength & Stability Specialist',
        image: '/assets/images/v63.jpg',
        experience: '11+ Years',
        category: 'bands',
        intro: `Nathan Brooks discovered his passion for rehabilitation after overcoming a devastating sports injury that threatened to end his athletic career. With his balanced physique, compassionate demeanor, and methodical approach, Nathan specializes in recovery-focused training that bridges the gap between physical therapy and performance training. After years working in rehabilitation clinics with professional athletes, he developed systematic approaches to rebuild strength and mobility for long-term function. "Recovery isn't just about healing—it's about building back stronger," is his guiding principle when coaching. Nathan's unique background combining physical therapy, sports science, and strength training creates distinctively effective programs that develop resilient bodies capable of extraordinary performance.`,
        programs: nathanBrooksPrograms
    },
    'jasmine-carter': {
        id: 'jasmine-carter',
        name: 'Jasmine Carter',
        specialization: 'Rehabilitation & Recovery Specialist',
        image: '/assets/images/v77.jpg',
        experience: '8+ Years',
        category: 'bands',
        intro: `Jasmine Carter developed her expertise in athletic conditioning through her background as a collegiate track star and later as a performance coach for elite athletes. With her athletic build, confident demeanor, and dynamic approach, Jasmine specializes in high-intensity training that develops explosive power and functional athleticism. After setting records in sprint events, she refined her methodology to create comprehensive conditioning programs accessible to athletes of all levels. "Consistent intensity creates breakthrough results," is her training philosophy. Jasmine's background blending sprint mechanics, strength training, and metabolic conditioning creates uniquely effective programs that develop exceptional athletic capabilities alongside impressive physical performance.`,
        programs: jasmineCarterPrograms
    },
    'caleb-mitchell': {
        id: 'caleb-mitchell',
        name: 'Caleb Mitchell',
        specialization: 'High-Intensity Training Specialist',
        image: '/assets/images/v79.jpg',
        experience: '13+ Years',
        category: 'bands',
        intro: `Caleb Mitchell discovered his passion for resistance training through rehabilitation from a devastating sports injury. With his balanced physique, analytical approach, and methodical demeanor, Caleb specializes in dynamic resistance training that optimizes tension throughout complete ranges of motion. After working with elite athletes who needed alternatives to traditional weight training, he refined his methodology to make advanced resistance techniques accessible to all fitness levels. "The quality of resistance matters more than the quantity," is his core training philosophy. Caleb's unique background blending physical therapy, sports science, and resistance band expertise creates distinctively effective programs that develop exceptional strength alongside impressive movement capabilities.`,
        programs: calebMitchellPrograms
    }
};

// Export functions
export const getBandsTrainerData = (trainerId) => {
    return bandsTrainersData[trainerId] || null;
};

export const getAllBandsTrainers = () => {
    return Object.values(bandsTrainersData);
};

export default bandsTrainersData;